module.exports = __webpack_public_path__ + "img/firebase.1ec93155.svg";